import React, { Component } from 'react'
import { Switch, withRouter, Route } from 'react-router-dom'

import { ClientAdminRoute } from 'Config/Routing/auth'
import UserManagement from 'Containers/UserManagement'
import UserManagementLegacy from 'Containers/UserManagement/UserManagementLegacy'
import UserManagementDetailsAdd from '../../Containers/UserManagement/UserDetails/Add'
import { UserProfile } from '../../Containers/UserManagement/UserDetails/UserProfile'
import { CreateUser } from '../../Containers/UserManagement/UserDetails/CreateUser'
import UserManagementDetailsView from 'Containers/UserManagement/UserDetails/View'
import UserManagementDetailsEdit from 'Containers/UserManagement/UserDetails/Edit'
import { authorization } from '../../Module/Auth/Auth'
import { PATHS } from 'Config/Routing/paths'

class UserManagementRouter extends Component {
  render() {
    const isClient = authorization.isClient()

    return (
      <Switch>
        <Route exact path={`${this.props.match.url}`}>
          <ClientAdminRoute>
            {isClient ? <UserManagement /> : <UserManagementLegacy />}
          </ClientAdminRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.url}${
            PATHS.userManagement.userManagementDetailsCreate
          }`}
        >
          <ClientAdminRoute>
            {isClient ? <CreateUser /> : <UserManagementDetailsAdd />}
          </ClientAdminRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.url}${
            PATHS.userManagement.userManagementDetailsView
          }`}
        >
          <ClientAdminRoute>
            {isClient ? <UserProfile /> : <UserManagementDetailsView />}
          </ClientAdminRoute>
        </Route>
        <Route
          exact
          path={`${this.props.match.url}${
            PATHS.userManagement.userManagementDetailsEdit
          }`}
        >
          <ClientAdminRoute>
            {isClient ? <UserProfile /> : <UserManagementDetailsEdit />}
          </ClientAdminRoute>
        </Route>
      </Switch>
    )
  }
}

export default withRouter(UserManagementRouter)
